<template>
  <div class="logo">
    <svg xmlns="http://www.w3.org/2000/svg" width="105" height="14" viewBox="0 0 105 14" fill="none">
      <path
          d="M90.0679 12.4287L95.2559 7.22985L90.8549 2.81956C90.4203 2.38398 90.4203 1.67779 90.8549 1.24221L92.0945 0L97.2827 5.19897L102.471 0L103.71 1.24221C104.145 1.67779 104.145 2.38398 103.71 2.81956L99.3092 7.22985L104.497 12.4287L103.258 13.6709C102.823 14.1065 102.118 14.1065 101.684 13.6709L97.2827 9.26074L92.8816 13.6709C92.447 14.1065 91.7421 14.1065 91.3075 13.6709L90.0679 12.4287Z"
          fill="#170101"/>
      <path
          d="M74.71 2.84437V13.9868H77.4957V2.84437H81.9526C82.5681 2.84437 83.0669 2.34546 83.0669 1.73012V0.0587589H69.1388V1.73012C69.1388 2.34546 69.6376 2.84437 70.2531 2.84437H74.71Z"
          fill="#170101"/>
      <path d="M85.2767 13.9868V1.173C85.2767 0.557666 85.7755 0.0587589 86.3909 0.0587589H88.0623V13.9868H85.2767Z"
            fill="#170101"/>
      <path
          d="M16.7137 1.173V13.9868H18.385C19.0005 13.9868 19.4993 13.4879 19.4993 12.8726V2.84437H23.6777V13.9868H26.4633V2.84437H30.6417V12.8726C30.6417 13.4879 31.1405 13.9868 31.7559 13.9868H33.4273V1.173C33.4273 0.557666 32.9285 0.0587589 32.3131 0.0587589H17.8279C17.2125 0.0587589 16.7137 0.557666 16.7137 1.173Z"
          fill="#170101"/>
      <path fill-rule="evenodd" clip-rule="evenodd"
            d="M47.3554 13.9868V8.41559H38.9985V13.9868H36.2129V1.173C36.2129 0.557666 36.7117 0.0587589 37.3272 0.0587589H50.141V13.9868H47.3554ZM47.3554 2.84437V5.62998H38.9985V2.84437H47.3554Z"
            fill="#170101"/>
      <path
          d="M52.9266 0.0587589H65.7404C66.3558 0.0587589 66.8546 0.557666 66.8546 1.173V8.41559H63.869L67.9451 12.4918L66.7634 13.6736C66.3282 14.1088 65.6229 14.1088 65.1876 13.6736L59.9296 8.41559H55.7122V13.9868H52.9266V5.62998H64.069V2.84437H54.0408C53.4254 2.84437 52.9266 2.34546 52.9266 1.73012V0.0587589Z"
          fill="#170101"/>
      <path
          d="M0 8.41559V1.173C0 0.557666 0.498798 0.0587589 1.11424 0.0587589H13.928V1.73012C13.928 2.34546 13.4292 2.84437 12.8138 2.84437H2.78561V5.62998H13.928V13.9868H0V12.3154C0 11.7001 0.498798 11.2012 1.11424 11.2012H11.1424V8.41559H0Z"
          fill="#170101"/>
    </svg>
  </div>
</template>
<script>

export default {
  name: 'Logo'
}

</script>
